import { NOMINATION_PANEL_CLOSING_STATUS } from 'constants/ProjectConstants';
import { noOp } from 'constants/helper';

import { SHOW_NOMINATE_PEERS_SIDEPANEL, HIDE_NOMINATE_PEERS_SIDEPANEL } from './actionTypes';

export const showNominatePeersSidePanelAction = ({
  reviewId,
  empId,
  emp,
  onSubmit = noOp,
  headerText = null,
  nominationEndDateTS,
}) => ({
  type: SHOW_NOMINATE_PEERS_SIDEPANEL,
  data: {
    reviewId,
    empId,
    onSubmit,
    headerText,
    emp,
    nominationEndDateTS,
  },
});

export const hideNominatePeersSidePanelAction = ({ closingStatus = NOMINATION_PANEL_CLOSING_STATUS.SUCCESSFUL }) => ({
  type: HIDE_NOMINATE_PEERS_SIDEPANEL,
  data: { closingStatus },
});
